import Details from '@/components/Details/Details';
import IEventType from '@/types/IEventType';
import { IEventTypeWrite } from '@/types/apiClient/IEventTypeWrite';
import { Divider } from '@chakra-ui/react';
import { FcConferenceCall } from 'react-icons/fc';
import EditAvailabilityModal from './edit-availability-modal/edit-availability.modal';
import RequiredParticipants from './required-participants/required-participants.view';
import RoundRobinParticipants from './round-robin-participants/round-robin-participants.view';
import { useSectionParticipants } from './section-participants.controller';

export interface IProps {
	service: IEventType;
	onChange: (values: Partial<IEventTypeWrite>) => void;
}

export default function SectionParticipants(props: IProps) {
	const { t, openModal, closeModal, isModalOpen, editResourceId } = useSectionParticipants();

	return (
		<Details image={<FcConferenceCall />} title={t('Attendees')}>
			<RequiredParticipants eventType={props.service} onChange={props.onChange} onEditAvailabilityClick={openModal} />
			<Divider mb={4} />
			<RoundRobinParticipants eventType={props.service} onChange={props.onChange} />
			{editResourceId ? <EditAvailabilityModal close={closeModal} isOpen={isModalOpen} id={editResourceId} /> : null}
		</Details>
	);
}
